const actions = {
    FETCH_SANDWICHES: 'FETCH_SANDWICHES',
    RESET_SANDWICH: 'RESET_SANDWICH',

    fetchSandwichesAction: (data) => {
        return {
            type: actions.FETCH_SANDWICHES,
            data: data
        };
    },

    resetSandwichFormAction: () => {
        return {
            type: actions.RESET_SANDWICH,
            data: null
        };
    },
};

export default actions;
